import { createContext, useContext } from 'react';

export interface KeepAliveContextValue {
  isActive: boolean;
}

export const KeepAliveContext = createContext<KeepAliveContextValue>({
  isActive: true,
});

export function useKeepAliveActive(): boolean {
  return useContext(KeepAliveContext).isActive;
}
